import {
	REFERRAL_COOKIE,
	REFERRAL_INFO_COOKIE,
	SOCIAL_TRADING_REFERRAL_TYPE,
	TWO_DAYS_EXPIRY
} from "@helpers/constants";
import { Helper } from "@helpers/functions";

interface ReferralInfo {
	type: typeof SOCIAL_TRADING_REFERRAL_TYPE;
}

export function setReferralCookies(referralId: string): void {
	if (isValidReferralId(referralId)) {
		const referralInfo: ReferralInfo = {
			type: SOCIAL_TRADING_REFERRAL_TYPE
		};
		const expiryDate = new Date(Date.now() + TWO_DAYS_EXPIRY);
		Helper.setCookie(REFERRAL_COOKIE, referralId, false, true, true, true, expiryDate);
		Helper.setCookie(REFERRAL_INFO_COOKIE, JSON.stringify(referralInfo), false, true, true, true, expiryDate);
	}
}

function isValidReferralId(id: string): boolean {
	return id.trim().length > 0;
}
